import { Logger } from "@iloq/shared";
import { AxiosInstance } from "axios";

/** ReactAppContainer needs to call setAuthInterceptors, which actually resides in the frontend project.
 * This a workaround to avoid circular dependencies.
 * Same with hasRefreshToken. */
export class AuthReferences {
  private static authInterceptorsReferenceFn: ((axios: AxiosInstance) => void) | undefined;
  private static versionInterceptorReferenceFn: ((axios: AxiosInstance) => void) | undefined;
  private static hasRefreshTokenFn: (() => boolean) | undefined;

  static setAuthInterceptorsReferenceFn(fn: (axios: AxiosInstance) => void) {
    this.authInterceptorsReferenceFn = fn;
  }

  static setVersionInterceptorReferenceFn(fn: (axios: AxiosInstance) => void) {
    this.versionInterceptorReferenceFn = fn;
  }

  static setHasRefreshTokenFn(fn: () => boolean) {
    this.hasRefreshTokenFn = fn;
  }

  static setAuthInterceptors(axios: AxiosInstance): void {
    if (!this.authInterceptorsReferenceFn) {
      Logger.error("AuthReferences authInterceptorsReferenceFn is not set");
      return;
    }
    this.authInterceptorsReferenceFn(axios);
  }

  static setVersionInterceptor(axios: AxiosInstance): void {
    if (!this.versionInterceptorReferenceFn) {
      Logger.error("AuthReferences versionInterceptorReferenceFn is not set");
      return;
    }
    this.versionInterceptorReferenceFn(axios);
  }

  static hasRefreshToken(): boolean {
    if (!this.hasRefreshTokenFn) {
      Logger.error("AuthReferences hasRefreshTokenFn is not set");
      return false;
    }
    return this.hasRefreshTokenFn();
  }
}
